/**
 * Footer - minimal Stripe-style footer.
 * Single line on desktop, wrapped on mobile.
 */

import React from 'react';
import { styled } from '@mui/material/styles';
import packageJson from '../../../package.json';

const Root = styled('footer')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 16,
  height: 48,
  padding: '0 20px',
  backgroundColor: theme.tokens.footerBg,
  borderTop: `1px solid ${theme.tokens.border}`,
  color: theme.tokens.footerFg,
  fontSize: 12,
  boxSizing: 'border-box',
  flexShrink: 0,
  '@media (max-width: 600px)': {
    height: 'auto',
    padding: '10px 16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 6,
  },
}));

const Meta = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
});

const Links = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  flexWrap: 'wrap',
});

const FooterLink = styled('a')(({ theme }) => ({
  color: theme.tokens.footerFg,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline', color: theme.tokens.fgSecondary },
}));

const Dot = styled('span')({
  opacity: 0.4,
});

export function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <Root>
      <Meta>
        <span>© {year} Clarivate</span>
        <Dot>·</Dot>
        <span>v{packageJson.version}</span>
      </Meta>
      <Links>
        <FooterLink
          href="https://clarivate.com/legal-center/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Legal Center
        </FooterLink>
        <FooterLink
          href="https://clarivate.com/privacy-center/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Notice
        </FooterLink>
        <FooterLink
          href="https://clarivate.com/privacy-center/notices-policies/cookie-notice/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Cookie Policy
        </FooterLink>
      </Links>
    </Root>
  );
}
